import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import DatePicker from "react-datepicker";
import IndicatorCheckin from "../Components/IndicatorCheckin";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCheck,
  faPencilAlt,
  faTimes,
  faTimesCircle,
  faTrash,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import "./IndicatorDetails.css";
import "react-datepicker/dist/react-datepicker.css";

function IndicatorDetails() {
  const [id, setId] = useState("");
  const [userName, setUserName] = useState("");
  const [description, setDescription] = useState("");
  const [indicatorUserId, setIndicatorUserId] = useState("");
  const [weight, setWeight] = useState(0);
  const [status, setStatus] = useState("");
  const [approverId, setApproverId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [level, setLevel] = useState(0);
  const [type, setType] = useState("");
  const [lastCheckIns, setLastCheckIns] = useState([]);
  const [newDate, setNewDate] = useState(new Date());
  const [note, setNote] = useState("");
  const [show, setShow] = useState(false);
  const [showAlt, setShowAlt] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showChangeDate, setShowChangeDate] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [reportedCheckInLevel, setReportedCheckInLevel] = useState(0);
  const [reportedCheckInCompleted, setReportedCheckInCompleted] =
    useState(false);
  const [reportedCheckInDate, setReportedCheckInDate] = useState(new Date());
  const [reportedCheckInId, setReportedCheckInId] = useState("");
  const [validatedCheckInLevel, setValidatedCheckInLevel] = useState(0);
  const [validatedCheckInCompleted, setValidatedCheckInCompleted] =
    useState(false);
  const [validatedCheckInNote, setValidatedCheckInNote] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  const [minRange, setMinRange] = useState(0);
  const [maxRange, setMaxRange] = useState(0);
  const [file, setFile] = useState({});

  const handleLevelChange = (e) => {
    setLevel(e.target.value);
  };

  const { state } = useContext(AuthContext);

  const { iid } = useParams();

  const dayjs = require("dayjs");

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.indicator.description);
      setIndicatorUserId(response.data.indicator.userId);
      setUserName(response.data.userName);
      setWeight(response.data.indicator.weight);
      setStatus(response.data.indicator.status);
      setApproverId(response.data.indicator.approverId);
      setId(response.data.indicator._id);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.indicator.rejectionMessage);
      setType(response.data.indicator.type);
      setCompleted(response.data.indicator.completed);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId, iid]);

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleValidationNoteChange = (e) => {
    setValidatedCheckInNote(e.target.value);
  };

  const handleValidationLevelChange = (e) => {
    setValidatedCheckInLevel(e.target.value);
  };

  const handleValidationCompletedChange = (e) => {
    setValidatedCheckInCompleted(e.target.checked);
  };

  const handleShowValidation = (
    id,
    reportedLevel,
    reportedCheckInCompleted,
    reportedDate,
  ) => {
    setReportedCheckInId(id);
    setReportedCheckInLevel(reportedLevel);
    setReportedCheckInCompleted(reportedCheckInCompleted);
    setReportedCheckInDate(reportedDate);
    setShowValidation(true);
  };

  const handleCloseValidation = () => setShowValidation(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowChangeDate = (id) => {
    setReportedCheckInId(id);
    setShowChangeDate(true);
  };
  const handleCloseChangeDate = () => setShowChangeDate(false);

  const handleCloseReject = () => setShowReject(false);

  const handleShowReject = (id) => {
    setReportedCheckInId(id);
    setShowReject(true);
  };

  const handleCloseAlt = () => {
    setRejectionMessage("");
    setShowAlt(false);
  };
  const handleShowAlt = () => setShowAlt(true);

  const selectStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "pending-status-label";
      case "approved":
        return "";
      case "rejected":
        return "rejected-status-label";
      default:
        return "pending-status-label";
    }
  };

  const selectStatusText = (status, language) => {
    let text = "";
    switch (status) {
      case "pending":
        if (language === "es") {
          text = "Pendiente";
        } else if (language === "en") {
          text = "Pending";
        }
        return text;
      case "approved":
        return "";
      case "rejected":
        if (language === "es") {
          text = "Rechazado";
        } else if (language === "en") {
          text = "Rejected";
        }
        return text;
      default:
        if (language === "es") {
          text = "Pendiente";
        } else if (language === "en") {
          text = "Pending";
        }
        return text;
    }
  };

  const handleCompletedChange = (e) => {
    setCompleted(e.target.checked);
  };

  const handleEvidenceChange = (e) => {
    setFile({ name: e.target.name, file: e.target.files[0] });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append(file.name, file.file);
    formData.append("checkinLevel", level);
    formData.append("note", note);
    formData.append("checkInCompleted", completed);
    formData.append("id", id);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/add/checkin/update/${id}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myindicators");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const deleteIndicator = async (id) => {
    try {
      setIsLoading(true);
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myindicators", {
        state: { tabKey: "MyTeam", currentUser: indicatorUserId },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const approveIndicator = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/status/${id}`,
        data: {
          status: "approved",
          rejectionMessage: "",
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      if (
        (state.role === "admin" && indicatorUserId !== state.userId) ||
        (state.role === "root" && indicatorUserId !== state.userId)
      ) {
        navigate(`/myindicators/person/${indicatorUserId}`);
        return;
      } else {
        navigate("/myindicators", {
          state: { tabKey: "MyTeam", currentUser: indicatorUserId },
        });
      }
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const rejectIndicator = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/status/${id}`,
        data: {
          status: "rejected",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myindicators", {
        state: { tabKey: "MyTeam", currentUser: indicatorUserId },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const closeIndicator = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/status/${id}`,
        data: {
          status: "closed",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myindicators", {
        state: { tabKey: "MyTeam", currentUser: indicatorUserId },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleDownloadEvidence = async (evidence) => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/indicators/download/file`,
      data: {
        key: evidence,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    const link = document.createElement("a");
    link.download = "evidence";

    link.target = "_blank";

    link.href = response.data.url;

    link.click();
  };

  const validateCheckIn = async (checkInId) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/checkin/${checkInId}`,
        data: {
          validatedLevel: validatedCheckInLevel,
          validatedCompleted: validatedCheckInCompleted,
          validationMessage: validatedCheckInNote,
          indicatorId: iid,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.indicator.description);
      setIndicatorUserId(response.data.indicator.userId);
      setWeight(response.data.indicator.weight);
      setStatus(response.data.indicator.status);
      setApproverId(response.data.indicator.approverId);
      setId(response.data.indicator._id);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.indicator.rejectionMessage);
      setType(response.data.indicator.type);
      setCompleted(response.data.indicator.completed);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);
      handleCloseValidation();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const unValidateCheckIn = async (checkInId) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/unvalidate/checkin/${checkInId}`,
        data: {
          indicatorId: iid,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.indicator.description);
      setIndicatorUserId(response.data.indicator.userId);
      setWeight(response.data.indicator.weight);
      setStatus(response.data.indicator.status);
      setApproverId(response.data.indicator.approverId);
      setId(response.data.indicator._id);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.indicator.rejectionMessage);
      setType(response.data.indicator.type);
      setCompleted(response.data.indicator.completed);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectCheckIn = async (checkInId) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/reject/checkin/${checkInId}`,
        data: {
          indicatorId: iid,
          validationMessage: validatedCheckInNote,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.indicator.description);
      setIndicatorUserId(response.data.indicator.userId);
      setWeight(response.data.indicator.weight);
      setStatus(response.data.indicator.status);
      setApproverId(response.data.indicator.approverId);
      setId(response.data.indicator._id);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.indicator.rejectionMessage);
      setType(response.data.indicator.type);
      setCompleted(response.data.indicator.completed);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);
      handleCloseReject();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const changeCheckInDate = async (checkInId) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/update/change/checkin/date/${checkInId}`,
        data: {
          indicatorId: iid,
          newDate: newDate,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.indicator.description);
      setIndicatorUserId(response.data.indicator.userId);
      setWeight(response.data.indicator.weight);
      setStatus(response.data.indicator.status);
      setApproverId(response.data.indicator.approverId);
      setId(response.data.indicator._id);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.indicator.rejectionMessage);
      setType(response.data.indicator.type);
      setCompleted(response.data.indicator.completed);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);
      handleCloseChangeDate();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="justify-content-center align-items-center mb-3">
          <Col lg={10}>
            <h2 className="mb-0">{userName}</h2>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-start">
          <Col lg={6}>
            {rejectionMessage !== "" ? (
              <Col className="mb-3">
                <Alert variant="danger">{rejectionMessage}</Alert>
              </Col>
            ) : (
              <></>
            )}

            <Row className="justify-content-center align-items-center">
              <Col>
                <h5>{t("Indicadores.Detalles.Titulo")}</h5>
              </Col>
              <Col className="right">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <FontAwesomeIcon icon={faBars} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {(status === "pending" || status === "rejected") &&
                    indicatorUserId === state.userId ? (
                      <Dropdown.Item as={Link} to={`/indicators/edit/${id}`}>
                        <FontAwesomeIcon icon={faPencilAlt} />{" "}
                        {t("Indicadores.Detalles.Editar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {(status === "pending" && approverId === state.userId) ||
                    (status === "pending" && state.role === "root") ? (
                      <Dropdown.Item onClick={() => approveIndicator(id)}>
                        <FontAwesomeIcon icon={faCheck} />{" "}
                        {t("Indicadores.Detalles.Aprobar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {status === "pending" && approverId === state.userId ? (
                      <Dropdown.Item onClick={() => handleShowAlt()}>
                        <FontAwesomeIcon icon={faTimes} />{" "}
                        {t("Indicadores.Detalles.Rechazar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {(status === "pending" || status === "rejected") &&
                    indicatorUserId === state.userId ? (
                      <Dropdown.Item onClick={() => handleShow()}>
                        <FontAwesomeIcon icon={faTrash} />{" "}
                        {t("Indicadores.Detalles.Eliminar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {/* {status === "approved" && approverId === state.userId ? (
                      <Dropdown.Item onClick={() => validateIndicator(id)}>
                        <FontAwesomeIcon icon={faCheckCircle} />{" "}
                        {t("Indicadores.Detalles.ValidarCumplimiento")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )} */}
                    {(status === "pending" || status === "approved") &&
                    indicatorUserId === state.userId ? (
                      <Dropdown.Item
                        onClick={() => navigate(`/indicators/invite/${id}`)}
                      >
                        <FontAwesomeIcon icon={faUserPlus} />{" "}
                        {t("Indicadores.Detalles.InvitarObservadores")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {status === "approved" &&
                    indicatorUserId === state.userId ? (
                      <Dropdown.Item onClick={() => closeIndicator(id)}>
                        <FontAwesomeIcon icon={faTimesCircle} />{" "}
                        {t("Indicadores.Detalles.CerrarIndicador")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Col className="indicator-card-details">
              <Row className="align-items-center mb-3">
                <Col>
                  <span className="weight-label">{weight}%</span>
                </Col>
                <Col className="right">
                  <span className={selectStatusClass(status)}>
                    {selectStatusText(status)}
                  </span>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col>
                  <Col className="range-container">
                    <p className="range">
                      {type === "completive" ? "N/A" : minRange}
                    </p>
                    <h6 className="rangeLabel">
                      {t("Indicadores.Detalles.Minimo")}
                    </h6>
                  </Col>
                </Col>
                <Col className="right">
                  <Col className="range-container">
                    <p className="range">
                      {type === "completive" ? "N/A" : maxRange}
                    </p>
                    <h6 className="rangeLabel">
                      {t("Indicadores.Detalles.Maximo")}
                    </h6>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col className="center">
                  <p className="indicatorDescription">{description}</p>
                </Col>
              </Row>
            </Col>
            <h5>{t("Indicadores.Detalles.UltimosCheckIns")}</h5>
            {lastCheckIns.length === 0 ? (
              <Col className="last-checkin">
                <p className="no-checkins">
                  {t("Indicadores.Detalles.NoCheckIns")}
                </p>
              </Col>
            ) : (
              lastCheckIns.map((checkin) => (
                <IndicatorCheckin
                  key={checkin._id}
                  checkIn={checkin}
                  type={type}
                  minRange={minRange}
                  maxRange={maxRange}
                  handleDownloadEvidence={handleDownloadEvidence}
                  handleShowValidation={handleShowValidation}
                  handleShowReject={handleShowReject}
                  handleShowChangeDate={handleShowChangeDate}
                  unValidateCheckIn={unValidateCheckIn}
                  indicatorUserId={indicatorUserId}
                  currentUserId={state.userId}
                  approverId={approverId}
                  language={state.language}
                  role={state.role}
                />
              ))
            )}
            {(state.role === "admin" && indicatorUserId !== state.userId) ||
            (state.role === "root" && indicatorUserId !== state.userId) ? (
              <Button
                className="btn btn-secondary"
                onClick={() =>
                  navigate(`/myindicators/person/${indicatorUserId}`)
                }
              >
                {t("Indicadores.Detalles.Regresar")}
              </Button>
            ) : (
              <Button
                className="btn btn-secondary"
                onClick={() =>
                  navigate("/myindicators", {
                    state: {
                      tabKey:
                        indicatorUserId === state.userId
                          ? "MyIndicators"
                          : "MyTeam",
                    },
                  })
                }
              >
                {t("Indicadores.Detalles.Regresar")}
              </Button>
            )}
          </Col>
          <Col lg={4}>
            <Row>
              <Col className="mt-3 mb-1">
                <h5>{t("Indicadores.Detalles.NuevoCheckIn")}</h5>
              </Col>
            </Row>

            <Col className="new-checkin-form">
              <Col className="mt-2">
                {type === "completive" ? (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t("Indicadores.Detalles.Completado")}
                    </Form.Label>
                    <Form.Check // prettier-ignore
                      type="switch"
                      id="custom-switch"
                      onChange={handleCompletedChange}
                    />
                  </Form.Group>
                ) : (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t("Indicadores.Detalles.NivelAlMomento")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      onChange={handleLevelChange}
                      disabled={
                        status !== "approved" ||
                        indicatorUserId !== state.userId
                      }
                    />
                  </Form.Group>
                )}
              </Col>
              <Col>
                <Form.Label>{t("Indicadores.Detalles.Nota")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  onChange={handleNoteChange}
                  value={note}
                  disabled={
                    status !== "approved" || indicatorUserId !== state.userId
                  }
                />
              </Col>
              <Col className="mt-3 mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>{t("Indicadores.Detalles.Evidencia")}</Form.Label>
                  <Form.Control
                    type="file"
                    name="evidence"
                    onChange={(e) => handleEvidenceChange(e)}
                    disabled={
                      status !== "approved" || indicatorUserId !== state.userId
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <Button
                    variant="primary"
                    disabled={
                      status !== "approved" || indicatorUserId !== state.userId
                    }
                    onClick={handleSubmit}
                  >
                    {t("Indicadores.Detalles.RegistrarCheckIn")}
                  </Button>
                </Form.Group>
              </Col>
            </Col>
          </Col>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Indicadores.Detalles.EliminarIndicador")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Indicadores.Detalles.EstasSeguroEliminar")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => deleteIndicator(id)}>
              {t("Indicadores.Detalles.Eliminar")}
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              {t("Indicadores.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showAlt} onHide={handleCloseAlt}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Indicadores.Detalles.RechazarIndicador")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("Indicadores.Detalles.RazonRechazo")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rejectionMessage}
                onChange={(e) => setRejectionMessage(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => rejectIndicator(id)}>
              {t("Indicadores.Detalles.Rechazar")}
            </Button>
            <Button variant="secondary" onClick={handleCloseAlt}>
              {t("Indicadores.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showValidation} onHide={handleCloseValidation}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Indicadores.Detalles.ValidarCheckIn")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Label>
                  {t("Indicadores.Detalles.FechaCheckIn")}
                </Form.Label>
                <p className="reportedCheckInDate">
                  {dayjs(reportedCheckInDate).format("D-MMM-YYYY")}
                </p>
              </Col>
              <Col className="right">
                <Form.Label>
                  {t("Indicadores.Detalles.NivelReportado")}
                </Form.Label>
                <p className="reportedCheckInLevel">
                  {type === "completive"
                    ? reportedCheckInCompleted
                      ? "Completado"
                      : "No Completado"
                    : reportedCheckInLevel}
                </p>
              </Col>
            </Row>
            <Col className="mt-3 mb-3">
              <Form.Label>{t("Indicadores.Detalles.NivelReal")}</Form.Label>
              <Row className="justify-content-center align-items-center">
                <Col>
                  {type === "completive" ? (
                    <Form.Check
                      type="switch"
                      label={
                        validatedCheckInCompleted
                          ? state.language === "es"
                            ? "Completado"
                            : "Completed"
                          : state.language === "es"
                            ? "No Completado"
                            : "Not Completed"
                      }
                      onChange={handleValidationCompletedChange}
                    />
                  ) : (
                    <Form.Control
                      type="number"
                      onChange={handleValidationLevelChange}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>{t("Indicadores.Detalles.Comentarios")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={validatedCheckInNote}
                  onChange={(e) => handleValidationNoteChange(e)}
                />
              </Form.Group>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => validateCheckIn(reportedCheckInId)}
            >
              {t("Indicadores.Detalles.Validar")}
            </Button>
            <Button variant="secondary" onClick={handleCloseValidation}>
              {t("Indicadores.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showReject} onHide={handleCloseReject}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Indicadores.Detalles.RechazarCheckIn")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>{t("Indicadores.Detalles.Comentarios")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={validatedCheckInNote}
                  onChange={(e) => handleValidationNoteChange(e)}
                />
              </Form.Group>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => rejectCheckIn(reportedCheckInId)}
            >
              {t("Indicadores.Detalles.Rechazar")}
            </Button>
            <Button variant="secondary" onClick={handleCloseReject}>
              {t("Indicadores.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showChangeDate} onHide={handleCloseChangeDate}>
          <Modal.Header closeButton>
            <Modal.Title>Cambiar fecha de check-in</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>{t("Indicadores.Detalles.NuevaFecha")}</Form.Label>
                <DatePicker
                  selected={newDate}
                  onChange={(date) => setNewDate(date)}
                />
              </Form.Group>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => changeCheckInDate(reportedCheckInId)}
            >
              {t("Indicadores.Detalles.CambiarFecha")}
            </Button>
            <Button variant="secondary" onClick={handleCloseChangeDate}>
              {t("Indicadores.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}
export default IndicatorDetails;
